import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const PageHeader = ({ title, subtitle, actions }) => (
  <Box sx={{ mb: 3 }}>
    <Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ md: 'center' }} spacing={1.5}
           justifyContent="space-between">
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>{title}</Typography>
        {subtitle ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{subtitle}</Typography>
        ) : null}
      </Box>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        {actions}
      </Stack>
    </Stack>
  </Box>
);

export default PageHeader;
